import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Col,
  Row,
  Spin,
  Upload,
  VertButton,
  VertContainer,
  VertTypography,
  message,
} from '@vertem-core/vertice-ds';

import { useNavigate, useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import GeneratePDFTerm from './GeneratePDFTerm';
import { useMediaQuery } from 'react-responsive';
import { UploadOutlined } from '@ant-design/icons';
import redemptionsApiClient from 'Services/Apis/Spot/redemptionsClient';

import Dragger from 'antd/es/upload/Dragger';
import ModalApprove from './VertModalAprove';
import ModalCancel from './VertModalCancel';
import PDFTerm from './PDFTermHierarchy';
import { usePDF } from '@react-pdf/renderer';
import { setTermUrl } from 'redux/Reducers/Spot/spotAproveHierarchy';
import useParticipantSubSegment from 'Hooks/useParticipantSubSegment';
import usePipeContext from 'Services/Providers/PipeProvider/usePipeContext';
import generateUUID from 'Utils/generateUUID';

const SpotTerms = ({
  data,
  spot,
  callModalDocuments,
  products,
  isLoading,
  isManager,
  termDownloadUrl,
}) => {
  const { callApi } = usePipeContext();
  const userProfile = useSelector((state) => state.oidc.user.profile);
  const userInfos = useSelector(({ oidc: data }) => data);
  const hasUndeliveredProducts = products.some((x) => x.delivery === false);
  const params = useParams();
  const { isLead, isPMO } = useParticipantSubSegment();

  const isLeaderShipConfirmSpotHierarchy = isLead && spot.redemptionStatusId === 10;

  const {
    user: { profile, access_token },
  } = userInfos;
  const username = profile.username || profile['custom:login'];

  const config = {
    campaignId: userProfile['custom:campaign_id'],
    catalogId: userProfile['custom:catalog_id'],
    participantId: userProfile['custom:participant_id'],
    Authorization: `Bearer ${access_token}`,
    username: username,
  };

  const participantId = userProfile['custom:participant_id'];

  const navigate = useNavigate();
  const { termUrl } = useSelector((state) => state.SpotApproveHierarchy);
  const mediaQuery = useMediaQuery({ maxWidth: 767 });
  const dispatch = useDispatch();
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [isVisibleModalCancel, setIsVisibleModalCancel] = useState(false);
  const [isVisibleModalAprovePMO, setIsVisibleModalAprovePMO] = useState(false);
  const [isLoadingAction, setLoadingAction] = useState(false);
  const [botaoValido, setBotaoValido] = useState(false);
  const [instance, updateInstance] = usePDF({
    document: <PDFTerm data={data} products={products} />,
  });

  useEffect(() => {
    if (isManager && spot.redemptionStatusId === 4) {
      if (termUrl === null || termUrl === undefined || termUrl === '') {
        setBotaoValido(true);
        return;
      }
      setBotaoValido(false);
    }
  }, [termUrl, spot.redemptionStatusId]);

  useEffect(() => {
    if (spot.redemptionStatusId === 4) {
      return () => {
        setBotaoValido(false);
        dispatch(setTermUrl(null));
      };
    }
  }, [spot.redemptionStatusId]);

  const uploadQuote = async () => {
    const formData = new FormData();

    setUploading(true);

    fileList.forEach((file) => {
      formData.append('file', file);
    });

    try {
      const response = await redemptionsApiClient.post(
        '/RedemptionFile/Upload',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            ...config,
          },
        }
      );
      dispatch(setTermUrl(response.data.url));
      message.success('Termo foi enviado com sucesso!');
    } catch (err) {
      console.log('uploadQuote err ::: ', err);
    } finally {
      setUploading(false);
    }
  };
  const callModal = (type) => {
    if (type === 'cancel') {
      setIsVisibleModalCancel(true);
    } else {
      setIsVisibleModalAprovePMO(true);
    }
  };
  const cancelHierarchy = async (values) => {
    const description = values.description;
    setIsVisibleModalCancel(false);
    setLoadingAction(true);
    const data = {
      redemptionId: params.id,
      description,
    };
    redemptionsApiClient
      .put(`/Redemption/Refuse`, data, {
        headers: {
          ...config,
        },
      })
      .then((res) => {
        navigate('/list-redemptions', {
          state: {
            spotCanceled: true,
            spotId: params.id,
          },
        });
      })
      .catch((err) => {
        console.log('Solicitation Error === ', err);
        message.error(
          'Não foi possível cancelar esta solicitação, valide as informações e tente novamente.'
        );
        setLoadingAction(false);
      });
  };
  const approveHierarchy = async (values) => {
    setLoadingAction(true);
    setIsVisibleModalAprovePMO(false);
    let productsIds = [];
    const description = values.description;

    products.map((product) => {
      return productsIds.push(product.id);
    });
    let _data = {};
    if (spot.redemptionStatusId === 4) {
      if (isPMO && (termUrl === null || termUrl === undefined || termUrl === '')) {
        message.error('É necessário enviar o termo de solicitação.');
        return;
      }
      _data = {
        redemptionId: spot.id,
        description,
        status: String(spot.participantId) === participantId ? 6 : 10,
        termUrl: termUrl,
        productsIds,
      };

    }

    if (isLeaderShipConfirmSpotHierarchy) {
      _data = {
        redemptionId: spot.id,
        description,
        status: 6,
        productsIds,
        termUrl: termDownloadUrl,
      };
    }

    
    redemptionsApiClient
      .put(`/Redemption/Approve`, _data, {
        headers: {
          ...config,
        },
        
      })
      .then((res) => {
        if (data.type === 3 && res?.data?.failed?.length > 0) {
          message.error(
            'Um ou mais produtos não foram aprovados. Entre em contato com o responsável. 1010'
          );
          setLoadingAction(false);
          return false;
        }

        callApi({
          symbol: 'LOAD_BALANCE',
          alias: generateUUID(),
        })
        message.success('Solicitação aprovada com sucesso!');
        navigate('/list-redemptions', {
          state: {
            spotApproved: true,
            spotId: data.id,
          },
        });
      })
      .catch((err) => {
        console.log('approveHierarchy Error === ', err);
        if (err?.response?.data?.code === '400001') {
          message.error('O saldo atual é inferior ao valor do produto.');
        } else {
          message.error(
            'Não foi possível aprovar a solicitação, valide as informações e tente novamente. 1515'
          );
        }
        setLoadingAction(false);
      });
  };

  return (
    <>
      {data && products && !instance.loading && !instance.error && (
        <>
          {isManager && !isLeaderShipConfirmSpotHierarchy && (
            <>
              <Row justify="center" className="row-button">
                <VertTypography.Paragraph className="title-terms-aprovation">
                  Para dar continuidade, essa solicitação precisa de sua
                  aprovação. O que deseja fazer?
                </VertTypography.Paragraph>
              </Row>

              <Row justify="center" className="row-button" gutter={[16, 16]}>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="title-terms-aprovation">
                    {mediaQuery && (
                      <VertButton
                        type="default"
                        className="button-view-redemption"
                        onClick={() => {
                          if (mediaQuery) {
                            callModalDocuments(2, instance.url);
                          }
                        }}
                      >
                        Enviar Termo
                      </VertButton>
                    )}
                    {!mediaQuery && (
                      <a
                        href={instance.url}
                        className="title-terms-aprovation"
                        target="_blank"
                      >
                        <VertButton
                          type="default"
                          className="button-view-redemption"
                        >
                          Baixar Termo de Solicitação
                        </VertButton>
                      </a>
                    )}
                  </div>
                </Col>
              </Row>

              <Row justify="center" gutter={[16, 16]} verticalSpacing="small">
                <VertTypography.Paragraph className="title-terms-aprovation">
                  Insira o termo de solicitação/aprovação do participante.
                </VertTypography.Paragraph>
                <Col xs={24} sm={12} md={8} lg={6}>
                  {mediaQuery && (
                    <Upload
                      customRequest={uploadQuote}
                      maxCount={1}
                      fileList={fileList}
                      listType="picture"
                      onRemove={(file) => {
                        const index = fileList.indexOf(file);
                        const newFileList = fileList.slice();
                        newFileList.splice(index, 1);
                        setFileList(newFileList);
                        dispatch(setTermUrl(null));
                      }}
                      beforeUpload={(file) => {
                        setFileList([file]);
                        return true;
                      }}
                      style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <VertButton
                        type="default"
                        icon={<UploadOutlined />}
                        block
                        loading={uploading}
                      >
                        {uploading
                          ? 'Enviando termo...'
                          : 'Clique para enviar termo'}
                      </VertButton>
                    </Upload>
                  )}

                  {!mediaQuery && (
                    <Dragger
                      customRequest={uploadQuote}
                      maxCount={1}
                      fileList={fileList}
                      listType="picture"
                      onRemove={(file) => {
                        const index = fileList.indexOf(file);
                        const newFileList = fileList.slice();
                        newFileList.splice(index, 1);
                        setFileList(newFileList);
                      }}
                      beforeUpload={(file) => {
                        setFileList([file]);
                        return true;
                      }}
                    >
                      <p className="ant-upload-drag-icon">
                        <UploadOutlined size={128} />
                      </p>
                      <VertTypography.Text className="ant-upload-hint">
                        Clique ou arraste o arquivo para esta área para enviar o
                        termo.
                      </VertTypography.Text>
                    </Dragger>
                  )}
                </Col>
              </Row>
            </>
          )}

          {isLeaderShipConfirmSpotHierarchy && (
            <>
              <Row justify="center" className="row-button">
                <VertTypography.Paragraph className="title-terms-aprovation">
                  Para dar continuidade, essa solicitação precisa de sua
                  aprovação. O que deseja fazer?
                </VertTypography.Paragraph>
              </Row>

              <Row justify="center" className="row-button" gutter={[16, 16]}>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="title-terms-aprovation">
                    {mediaQuery && (
                      <VertButton
                        type="default"
                        className="button-view-redemption"
                        onClick={() => {
                          if (mediaQuery) {
                            callModalDocuments(2, termDownloadUrl);
                          }
                        }}
                      >
                        Enviar Termo
                      </VertButton>
                    )}
                    {!mediaQuery && (
                      <a
                        href={termDownloadUrl}
                        className="title-terms-aprovation"
                        target="_blank"
                      >
                        <VertButton
                          type="default"
                          className="button-view-redemption"
                        >
                          Baixar Termo
                        </VertButton>
                      </a>
                    )}
                  </div>
                </Col>
              </Row>
            </>
          )}
          <Row justify="center" gutter={[16, 16]} verticalSpacing="regular">
            <Col xs={24} sm={12} md={8} lg={6}>
              <Button
                type="default"
                danger
                loading={isLoading || isLoadingAction}
                onClick={() => callModal('cancel')}
                className="button-view-redemption-danger"
              >
                Cancelar Solicitação
              </Button>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <VertButton
                type="highlight"
                disabled={
                  isLoadingAction ||
                  instance.loading ||
                  hasUndeliveredProducts ||
                  botaoValido
                }
                loading={isLoading || isLoadingAction}
                onClick={() => callModal('approve')}
                block
              >
                Aprovar Solicitação
              </VertButton>
            </Col>
          </Row>
          <Row
            justify="center"
            className="row-button"
            verticalSpacing="regular"
            gutter={[16, 16]}
          >
            <Col xs={24} sm={12} md={8} lg={6}>
              <VertButton
                type="default"
                className="button-view-redemption"
                loading={isLoading || isLoadingAction}
                onClick={() => navigate('/list-redemptions')}
              >
                Ver Solicitações
              </VertButton>
            </Col>
          </Row>

          <ModalCancel
            isVisible={isVisibleModalCancel}
            setIsVisible={setIsVisibleModalCancel}
            submitCancel={cancelHierarchy}
          />
          <ModalApprove
            isVisible={isVisibleModalAprovePMO}
            setIsVisible={setIsVisibleModalAprovePMO}
            submitApprove={approveHierarchy}
          />
        </>
      )}
    </>
  );
};

export default SpotTerms;

SpotTerms.propTypes = {
  spot: PropTypes.object.isRequired,
};
